import React, { useEffect, useState } from 'react';
import { Form, Button, Select, Spin, Switch, Checkbox } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store';
import { Store } from 'antd/lib/form/interface';
import { postPreferences, updatePreferences } from 'store/preferences';
import styled from 'styled-components';

import { SketchPicker, ColorResult } from 'react-color'

const Container = styled.div`
  max-width: 15rem;
`;
export const Preferences = () => {
  const [colorBtn, setColorBtn ] = useState<string>('')
  const { moneda, impuestos, impresion, tipoIva, color, usoNF, usoInfoAdicional, state } = useSelector(
    ({ preferences }: RootState) => preferences
  );
  const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false)

  const [form] = Form.useForm();  
  const dispatch = useDispatch();  

  useEffect(() => {
    dispatch(updatePreferences());
  }, [dispatch]);
  console.log(">>>>", moneda, impuestos, impresion, tipoIva, color);
  useEffect(() => {
    form.resetFields();
  }, [moneda, impuestos, impresion, tipoIva, color, usoNF, usoInfoAdicional, form]);
  useEffect(() => {
    setColorBtn(color); // default color #22194D
  }, [color])

  const handleFinish = (values: Store) => {          
    const { moneda, impuestos, impresion, tipoIva, usoNF, usoInfoAdicional } = values;        
    setDisplayColorPicker(false)    
    dispatch(postPreferences(moneda, impuestos, impresion, tipoIva, colorBtn, usoNF, usoInfoAdicional));
  };

  return (
    <Spin spinning={state === 'LOADING'}>
      <Container>
        <Form
          layout="vertical"
          form={form}
          initialValues={{ moneda, impuestos, impresion, tipoIva, usoNF, usoInfoAdicional,color }}
          onFinish={handleFinish}
        >
          <Form.Item name="impuestos" label="Pasar precios">
            <Select>
              <Select.Option value="IVA INC">IVA INC</Select.Option>
              <Select.Option value="+ IVA">+ IVA</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="moneda" label="Moneda preferencial">
            <Select>
              <Select.Option value="Pesos">Pesos</Select.Option>
              <Select.Option value="Dólares">Dólares</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="tipoIva" label="IVA">
            <Select>
              <Select.Option value="0%">0%</Select.Option>
              <Select.Option value="10%">10%</Select.Option>
              <Select.Option value="22%">22%</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="usoNF" label="Usar monto no facturable" valuePropName="checked">                        
            <Switch />
          </Form.Item>
          <Form.Item name="usoInfoAdicional" label="Usar información adicional" valuePropName="checked">                        
            <Switch />
          </Form.Item>
          <Form.Item name="impresion" label="Tipo Impresión">
            <Select>
              <Select.Option value="A4">A4</Select.Option>
              <Select.Option value="Térmico">Térmico</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name='color' valuePropName='color' trigger='onChangeComplete' label="Color de factura">
          <div 
            style={{
              padding: 5,
              background: '#fff',
              borderRadius: 1,
              boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
              display: 'inline-block',
              cursor: 'pointer',
          }}
            onClick={() => setDisplayColorPicker(!displayColorPicker)}
            >
              <div style={{
                  width: 36,
                  height: 14,
                  borderRadius: 2,
                  background: colorBtn
              }} />
          </div>
          
            {displayColorPicker && <SketchPicker 
              onChange={(color: ColorResult) => setColorBtn(color.hex)}
              />}
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Guardar
            </Button>
          </Form.Item>
        </Form>
      </Container>
    </Spin>
  );
};
